export const animations = {
  slideInUp: 'animate__animated animate__slideInUp', 
  fadeRight: 'animate__animated animate__fadeInRight',
  fadeLeft: 'animate__animated animate__fadeInLeft',
  fadeDown: 'animate__animated animate__fadeInDown',
  fadeUp: 'animate__animated animate__fadeInUp',
  fadeIn: 'animate__animated animate__fadeIn',
  fadeOut: 'animate__animated animate__fadeOut',
  fadeOutDown: 'animate__animated animate__fadeOutDown',
  slideOutDown: 'animate__animated animate__slideOutDown',
  flash: 'animate__animated animate__flash',
  pulse: 'animate__animated animate__pulse',
  rotate: 'animate__animated animate__rotateIn',
  shake: 'animate__animated animate__headShake',
}